/* ============================================================
   ASTON LUCAS GOURMET — shared page behaviour
   Loaded on every page. Wrapped in an IIFE so it can sit
   alongside the per-page scripts without clashing on names.

   1. Sticky header state
   2. Reveal-on-scroll
   3. Mobile navigation drawer  (the burger was previously dead
      below 1080px — the whole nav simply disappeared)
   4. Hero video
   ============================================================ */
(function () {

  /* ---------- 1. Sticky header ---------- */
  var topbar = document.getElementById('topbar');
  if (topbar) {
    var onScroll = function () {
      topbar.classList.toggle('is-stuck', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- 2. Reveal on scroll ----------
     The theme editor re-renders a section every time a setting changes, and the
     fresh markup has never been past the observer — so .reveal stayed at
     opacity:0 and the section went black the moment ALG touched an image.
     Observing is a function now and re-runs on shopify:section:load; inside the
     editor every reveal is simply shown, so nothing can hide while editing. */
  var designMode = window.Shopify && window.Shopify.designMode;

  var reveals = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = [].slice.call(scope.querySelectorAll('.reveal'));
    if (scope.classList && scope.classList.contains('reveal')) list.unshift(scope);
    return list;
  };

  var showAll = function (root) {
    reveals(root).forEach(function (el) { el.classList.add('in'); });
  };

  if (designMode || !('IntersectionObserver' in window)) {
    showAll(document);
    document.addEventListener('shopify:section:load', function (e) { showAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) { showAll(e.target); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var peers = [].slice.call(e.target.parentElement.children)
          .filter(function (c) { return c.classList.contains('reveal'); });
        e.target.style.transitionDelay = (Math.max(0, peers.indexOf(e.target)) % 3 * 80) + 'ms';
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    var observe = function (root) { reveals(root).forEach(function (el) { io.observe(el); }); };
    observe(document);
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  }

  /* ---------- 3. Desktop dropdowns ----------
     Hover still works. This adds the three ways in that hover can't cover:
       · click the caret to open (the word itself still goes to the page)
       · keyboard focus opens it, via :focus-within in the CSS
       · on a touch screen the first tap opens, the second follows the link */
  var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

  var closeMenus = function (except) {
    document.querySelectorAll('.nav__item.is-open').forEach(function (i) {
      if (i !== except) i.classList.remove('is-open');
    });
  };

  document.querySelectorAll('.nav__item').forEach(function (item) {
    var drop = item.querySelector('.drop');
    if (!drop) return;
    var link  = item.querySelector('.nav__link');
    var caret = item.querySelector('.nav__caret');

    var toggle = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var wasOpen = item.classList.contains('is-open');
      closeMenus();
      if (!wasOpen) item.classList.add('is-open');
    };

    if (caret) caret.addEventListener('click', toggle);

    link.addEventListener('click', function (e) {
      /* touch: don't jump to the parent collection before the customer has
         even seen that there are sub-collections underneath it */
      if (coarse && !item.classList.contains('is-open')) toggle(e);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item')) closeMenus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenus();
  });

  /* ---------- 4. Mobile drawer ----------
     Built from one menu definition so the drawer can never drift
     out of step with the desktop nav. */
  /* ---------- 4. Mobile drawer ----------
     The desktop nav and this drawer are built from the same Shopify menu,
     printed into the page by sections/header.liquid as #alg-menu, so the two
     cannot drift apart. Editing Settings -> Navigation changes both. */
  function menuData(){
    var tag = document.getElementById('alg-menu');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch (e) { return []; }
  }

  var MENU = menuData().map(function (g) {
    return {
      k: g.title,
      items: (g.children && g.children.length ? g.children : [{ title: g.title, url: g.url }])
               .map(function (c) { return [c.title, c.url]; })
    };
  });

  var SECONDARY = (window.ALG_SECONDARY_LINKS || []).map(function (l) { return [l.title, l.url]; });

  var burger = document.querySelector('.burger');
  if (!burger) return;

  var here = location.pathname.replace(/\/+$/, '') || '/';

  var groups = MENU.map(function (g) {
    var links = g.items.map(function (it) {
      var on = it[1].split('#')[0].replace(/\/+$/, '') === here ? ' class="on"' : '';
      return '<li><a href="' + it[1] + '"' + on + '>' + it[0] + '</a></li>';
    }).join('');
    return '<div class="dnav__g"><p class="dnav__k">' + g.k + '</p><ul class="dnav__list">' + links + '</ul></div>';
  }).join('');

  var secondary = SECONDARY.map(function (it) {
    return '<a href="' + it[1] + '">' + it[0] + '</a>';
  }).join('');

  var drawer = document.createElement('div');
  drawer.className = 'drawer';
  drawer.id = 'drawer';
  drawer.innerHTML =
    '<div class="drawer__scrim" data-close></div>' +
    '<div class="drawer__panel" role="dialog" aria-modal="true" aria-label="Menu">' +
      '<div class="drawer__top">' +
        '<a class="mark" href="' + (window.ALG_ROOT || '/') + '" aria-label="Home">' +
          '<img src="' + (window.ALG_LOGO || '') + '" alt=""></a>' +
        '<button class="drawer__close" data-close aria-label="Close menu">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" fill="none" stroke-width="1.1">' +
          '<path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '</div>' +
      '<nav class="dnav" aria-label="Mobile">' + groups + '</nav>' +
      '<div class="drawer__util">' + secondary + '</div>' +
    '</div>';
  document.body.appendChild(drawer);

  var open = function () {
    drawer.classList.add('open');
    document.body.classList.add('locked');
    burger.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('.drawer__close');
    if (first) first.focus();
  };
  var close = function () {
    drawer.classList.remove('open');
    document.body.classList.remove('locked');
    burger.setAttribute('aria-expanded', 'false');
    burger.focus();
  };

  burger.setAttribute('aria-expanded', 'false');
  burger.setAttribute('aria-controls', 'drawer');
  burger.addEventListener('click', open);
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target.closest('a')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });
  /* If the viewport grows past the breakpoint while the drawer is open,
     the desktop nav returns — leaving a locked body behind it. */
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1080 && drawer.classList.contains('open')) close();
  });

  /* ---------- 4. Hero video ----------
     hero.liquid holds the file in data-src and shows the poster until this
     runs, so a phone on mobile data never downloads it. Nothing was promoting
     it to src, so every visitor got the poster and the hero looked like a
     still. Narrow screens and reduced-motion keep the poster by design. */
  var heroVideo = document.querySelector('.hero__video');
  if (heroVideo && heroVideo.dataset.src) {
    var wide = window.matchMedia('(min-width: 700px)').matches;
    var motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (wide && motion) {
      heroVideo.src = heroVideo.dataset.src;
      /* Autoplay can still be refused — the poster stays put if it is. */
      var started = heroVideo.play();
      if (started && started.catch) started.catch(function () {});
    }
  }

})();
